import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(gas, normal, diagnosis, measure) {
  return { gas, normal, diagnosis, measure };
}

const rows = [
  createData('Hydrogen(H2)', 150, '', 12),
  createData('Methane(CH4)', 25, '', 3),
  createData('Ethane (C2H6)', 10, '', 3),
  createData('Ethylene (C2H4)', 20, 'Severe overheating', 22),
  createData('Acetylene (C2H2)', 15, '', 7),
  createData('Carbon Monoxide (CO)', 500, '', 225),
  createData('Carbon Dioxide (CO2)', 10000, '', 232),
  createData('Oxygen (O2)', 2000, '', 1566),
  createData('Nitrogen (N2)', '1-10%', '', 100),
  createData('CO2/CO', '3-10', 'Paper fault with temp >200 C', 2.0),
  createData('Total Combustible Gas:', 500, '', 272),
];

export default function DissolvedGases() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} size="small" aria-label="a dense table">
        <caption  style={{backgroundColor:'gray'}}>Normal aging - Analyse in 6-12 months</caption>
        <TableHead style={{backgroundColor:'gray'}}>
          <TableRow>
            <TableCell>Gas</TableCell>
            <TableCell align="right">Normal&nbsp;(ppm)</TableCell>
            <TableCell align="right">Diagnosis</TableCell>
            <TableCell align="right">3/6/2022</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.gas}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.gas}
              </TableCell>
              <TableCell align="right">{row.normal}</TableCell>
              <TableCell align="right" style={{background: row.gas === 'Ethylene (C2H4)' ? 'red' : 'white'}}>{row.diagnosis}</TableCell>
              <TableCell align="right" style={{background: row.gas === 'Ethylene (C2H4)' ? 'red' : 'white'}}>{row.measure}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
